import {useEffect, useState} from "react";
import {ProductInSearchParamType} from "./interface";
import {productInListMapInit, productInSearchParamInit} from "./state";
import {useReadProductIn} from "./hooks/useReadProductIn";
import Filter from "./features/Filter";
import List from "./features/List";
import {useSearchParams} from "react-router-dom";

export default function ProductInList() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<ProductInSearchParamType>(productInSearchParamInit)

    const {data: product} = useReadProductIn({param: searchParam});

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return <>
        <Filter searchParam={searchParam} setSearchParam={setSearchParam}/>

        <List product={product ?? productInListMapInit} searchParam={searchParam}/>
    </>
}